angular
  .module('contributor')

  .factory('TaskUnitCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class TaskUnitCrud extends Crud {
        constructor() {
          super(
            'task-unit',
            '@@apiUrl' + '/task-units' + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return TaskUnitCrud;
    }
  ]);
